'use strict';

module.exports = {
  RELATIVE_CULL_TOLERANCE: 1e-6
};